import { GameConfigs } from "../../lib/globals/GameConfigs";

const symbols = {
  USD: "$",
  EUR: "€",
  AED: "د.إ",
  ALL: "L",
  AMD: "Դ",
  ARS: "$",
  AUD: "A$",
  AZN: "₼",
  BDT: "৳",
  BGN: "Лв",
  BMD: "$",
  BRL: "R$",
  CAD: "C$",
  CDF: "FC",
  CHF: "₣",
  CLP: "$",
  CNY: "¥",
  COP: "$",
  CRC: "₡",
  CZK: "Kč",
  DKK: "Kr.",
  GBP: "£",
  GEL: "₾",
  GHS: "GH¢",
  GTQ: "Q",
  HKD: "HK$",
  HRK: "kn",
  HTG: "G",
  HUF: "Ft",
  IDR: "Rp",
  ILS: "₪",
  INR: "₹",
  IQD: "ع.د",
  IRR: "﷼",
  ISK: "Íkr",
  JPY: "¥",
  KES: "/=",
  KGS: "Лв",
  KRW: "₩",
  KWD: "د.ك",
  KYD: "$",
  KZT: "₸",
  MAD: "MAD",
  MDL: "L",
  MKD: "Ден",
  MMK: "K",
  MNT: "₮",
  MXN: "Mex$",
  MYR: "RM",
  NAD: "N$",
  NGN: "₦",
  NOK: "kr",
  NZD: "$",
  PEN: "S/",
  PLN: "zł",
  PYG: "₲",
  RON: "lei",
  RUB: "₽",
  SAR: "﷼",
  SEK: "kr",
  SGD: "S$",
  SLL: "Le",
  THB: "฿",
  TMT: "T",
  TND: "د.ت",
  TRY: "₺",
  TWD: "NT$",
  TZS: "TSh",
  UAH: "₴",
  UGX: "USh",
  UYU: "$U",
  UZS: "so'm",
  VND: "₫",
  XAF: "FCFA",
  XOF: "CFA",
  ZAR: "R",
  ZMW: "ZK",
  BAM: "KM",
  PHP: "₱",
  BYN: "Rbl",
  ETB: "ብር",
  PKR: "Rs",
  BTC: "BTC",
  ETH: "ETH",
  DOG: "DOG",
  DOGE: "DOGE",
  XDG: "XDG",
  USDT: "USDT",
  LTC: "LTC",
  BNB: "BNB",
  USDC: "USDC",
  mBTC: "mBTC",
  mETH: "mETH",
  EGP: "£",
  KHR: "₭",
  LAK: "₭",
  MVR: "Rf",
  MBC: "mBTC",
  FTN: "FTN",
  IRT: "IRT",

  SOS: "SOS",
  MBT: "mBT",
  VES: "Bs.S",
  TJS: "TJS",
  AOA: "AOA",
  BHD: "BHD",
  BOB: "BOB",
  BZD: "BZD",
  SKK: "SKK",
  DZD: "DZD",
  JOD: "JOD",
  MZN: "MZN",
  OMR: "OMR",
  QAR: "QAR",
  RSD: "RSD",
  SDG: "SDG",
  uBTC: "uBTC",
  mLTC: "mLTC",
  MBCH: "MBCH",
  TRX: "TRX",
  SHIB: "SHIB",
  XRP: "XRP",
};

const custom_symbols = {
  USD: "$",
  EUR: "€",
  AED: "AED",
  ALL: "ALL",
  AMD: "AMD",
  ARS: "ARS",
  AUD: "AUD",
  AZN: "AZN",
  BDT: "BDT",
  BGN: "BGN",
  BMD: "BMD",
  BRL: "BRL",
  CAD: "CAD",
  CDF: "CDF",
  CHF: "CHF",
  CLP: "CLP",
  CNY: "CNY",
  COP: "COP",
  CRC: "CRC",
  CZK: "CZK",
  DKK: "DKK",
  GBP: "GBP",
  GEL: "₾",
  GHS: "GHS",
  GTQ: "GTQ",
  HKD: "HKD",
  HRK: "HRK",
  HTG: "HTG",
  HUF: "HUF",
  IDR: "IDR",
  ILS: "ILS",
  INR: "INR",
  IQD: "IQD",
  IRR: "IRR",
  ISK: "ISK",
  JPY: "JPY",
  KES: "KES",
  KGS: "KGS",
  KRW: "KRW",
  KWD: "KWD",
  KYD: "KYD",
  KZT: "KZT",
  MAD: "MAD",
  MDL: "MDL",
  MKD: "MKD",
  MMK: "MMK",
  MNT: "MNT",
  MXN: "MXN",
  MYR: "MYR",
  NAD: "NAD",
  NGN: "NGN",
  NOK: "NOK",
  NZD: "NZD",
  PEN: "PEN",
  PLN: "PLN",
  PYG: "PYG",
  RON: "RON",
  RUB: "RUB",
  SAR: "SAR",
  SEK: "SEK",
  SGD: "SGD",
  SLL: "SLL",
  THB: "THB",
  TMT: "TMT",
  TND: "TND",
  TRY: "TRY",
  TWD: "TWD",
  TZS: "TZS",
  UAH: "UAH",
  UGX: "UGX",
  UYU: "UYU",
  UZS: "UZS",
  VND: "VND",
  XAF: "XAF",
  XOF: "XOF",
  ZAR: "ZAR",
  ZMW: "ZMW",
  BAM: "BAM",
  PHP: "PHP",
  BYN: "BYN",
  ETB: "ETB",
  PKR: "PKR",
  BTC: "BTC",
  ETH: "ETH",
  DOG: "DOG",
  DOGE: "DOGE",
  XDG: "XDG",
  USDT: "USDT",
  LTC: "LTC",
  BNB: "BNB",
  USDC: "USDC",
  mBTC: "mBTC",
  mETH: "mETH",
  EGP: "EGP",
  KHR: "KHR",
  LAK: "LAK",
  MVR: "MVR",
  MBC: "MBC",
  FTN: "FTN",
  IRT: "IRT",

  TJS: "TJS",
  SOS: "SOS",
  MBT: "mBT",
  VES: "Bs.S",
  AOA: "AOA",
  BHD: "BHD",
  BOB: "BOB",
  BZD: "BZD",
  SKK: "SKK",
  DZD: "DZD",
  JOD: "JOD",
  MZN: "MZN",
  OMR: "OMR",
  QAR: "QAR",
  RSD: "RSD",
  SDG: "SDG",
  uBTC: "uBTC",
  mLTC: "mLTC",
  MBCH: "MBCH",
  TRX: "TRX",
  SHIB: "SHIB",
  XRP: "XRP",
};

export function getCurrencySymbol(currency, custom) {
  let result = [symbols[currency], "left"];

  if (symbols[currency].length > 1) {
    result = [currency, "right"];
  }
  if (currency === "GEL") {
    result = [symbols[currency], "right"];
  }
  if (custom) {
    if (currency === "USD" || currency === "EUR") {
      result = [custom_symbols[currency], "left"];
    } else {
      result = [custom_symbols[currency], "right"];
    }
  }

  return result || [];
}

export function formatValue(value) {
  let res = parseFloat(value).toLocaleString(undefined, {
    minimumFractionDigits: GameConfigs.config.currency_prec,
    maximumFractionDigits: GameConfigs.config.currency_prec,
  });
  return res;
}

export function formatCurrencyValue(
  value,
  currency,
  prec,
  bonus,
  haveCurrency
) {
  const precision =
    prec !== undefined ? prec : GameConfigs.config.currency_prec;
  let res = parseFloat(value).toLocaleString(undefined, {
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  });

  if (currency[1] === "left") {
    res = currency[0] + res;
  } else {
    if (haveCurrency !== undefined) {
      return res;
    } else {
      res = res + " " + currency[0];
    }
  }
  // if (GameConfigs.auth.balance.currency === "GEL") {
  //   res = res + currency[0];
  // }
  if (bonus !== undefined && bonus) {
    res = parseFloat(value).toLocaleString();
  }

  return res;
}
